import * as t from "io-ts";
import fetchApi from "ui-io/fetch-api";
export const UserCodec = t.intersection([
  t.type({
    userId: t.string,
    name: t.string,
  }),
  t.partial({
    email: t.string,
    username: t.string,
    phoneNumber: t.string,
    profileImageUrl: t.string,
    designation: t.string,
    admins: t.array(t.unknown),
    tags: t.array(t.unknown),
    status: t.string,
    dob: t.string,
    roleInFirm: t.union([t.string, t.null]),
    subscriptionStatus: t.string,
    subscriptionTier: t.string,
    isEmailVerified: t.union([t.boolean, t.string]),
    orgName: t.string,
    address: t.UnknownRecord,
  }),
]);
export type UserT = t.TypeOf<typeof UserCodec>;

export const userProfileQuery = (userId: string) => {
  return {
    queryKey: ["GET_USER_PROFILE_DETAIL", userId],
    queryFn: () =>
      fetchApi({
        service: "user-service",
        headers: { method: "GET" },
        pathname: `/user-detail/${userId}`,
        codec: UserCodec,
      }),
  };
};
